{
	"navigation": {
		"moreLabel": "Περισσότερα"
	},
	"useDeclarationCreationFormStore": {
		"errorMessages": {
			"fetchDefaultMaterial": "Αποτυχία λήψης υλικού",
			"submitDeclaration": "Αποτυχία υποβολής δήλωσης"
		}
	},
	"country": {
		"AC": "Νησί της Ανάληψης",
		"AD": "Ανδόρα",
		"AE": "Ηνωμένα Αραβικά Εμιράτα",
		"AF": "Αφγανιστάν",
		"AG": "Αντίγκουα και Μπαρμπούντα",
		"AI": "Ανγκουίλα",
		"AL": "Αλβανία",
		"AM": "Αρμενία",
		"AO": "Αγκόλα",
		"AQ": "Ανταρκτική",
		"AR": "Αργεντίνη",
		"AS": "Αμερικανική Σαμόα",
		"AT": "Αυστρία",
		"AU": "Αυστραλία",
		"AW": "Αρούμπα",
		"AX": "Νησιά Åland",
		"AZ": "Αζερμπαϊτζάν",
		"BA": "Βοσνία-Ερζεγοβίνη",
		"BB": "Μπαρμπάντος",
		"BD": "Μπαγκλαντές",
		"BE": "Βέλγιο",
		"BF": "Μπουρκίνα Φάσο",
		"BG": "Βουλγαρία",
		"BH": "Μπαχρέιν",
		"BI": "Μπουρούντι",
		"BJ": "Μπενίν",
		"BL": "Άγιος Βαρθολομαίος",
		"BM": "Βερμούδα",
		"BN": "Μπρουνέι",
		"BO": "Βολιβία",
		"BQ": "Καραϊβική Ολλανδία",
		"BR": "Βραζιλία",
		"BS": "Μπαχάμες",
		"BT": "Μπουτάν",
		"BV": "Νησί Μπουβέ",
		"BW": "Μποτσουάνα",
		"BY": "Λευκορωσία",
		"BZ": "Μπελίζ",
		"CA": "Καναδάς",
		"CC": "Νησί Κόκος",
		"CD": "Κονγκό DR",
		"CEFTA": "Cefta",
		"CF": "Κεντροαφρικανική Δημοκρατία",
		"CG": "Δημοκρατία του Κονγκό",
		"CH": "Ελβετία",
		"CI": "Ακτή Ελεφαντοστού",
		"CK": "Νησιά Κουκ",
		"CL": "χιλή",
		"CM": "Καμερούν",
		"CN": "Κίνα",
		"CO": "Κολομβία",
		"CP": "Νησί Κλίπερτον",
		"CR": "Κόστα Ρίκα",
		"CU": "Κούβα",
		"CV": "Cabo Verde",
		"CW": "Κουράσω",
		"CX": "Νησί των Χριστουγέννων",
		"CY": "Κύπρος",
		"CZ": "Τσεχική Δημοκρατία",
		"DE": "Γερμανία",
		"DG": "Ντιέγκο Γκαρσία",
		"DJ": "Τζιμπουτί",
		"DK": "Δανία",
		"DM": "Δομίνικα",
		"DO": "Δομινικανή Δημοκρατία",
		"DZ": "Αλγερία",
		"ES": "Ισπανία",
		"EC": "Εκουαδόρ",
		"EE": "Εσθονία",
		"EG": "Αίγυπτος",
		"EH": "Δυτική Σαχάρα",
		"ER": "Ερυθραία",
		"CT": "Καταλονία (Ισπανία)",
		"PV": "Χώρα των Βάσκων (Ισπανία)",
		"ES-TR": "έδαφος της Ισπανίας",
		"ET": "Αιθιοπία",
		"EU": "Ευρωπαϊκή Ένωση",
		"FI": "Φινλανδία",
		"FJ": "Φίτζι",
		"FK": "Νησιά Φώκλαντ",
		"FM": "Μικρονησία",
		"FO": "Νησιά Φερόε",
		"FR": "Γαλλία",
		"GA": "Γκαμπόν",
		"ENG": "Αγγλία",
		"NIR": "Βόρεια Ιρλανδία",
		"SCT": "Σκωτία",
		"WLS": "Ουαλία",
		"GB": "Μεγάλη Βρετανία",
		"GD": "Γρενάδα",
		"GE": "Γεωργία",
		"GF": "Γαλλική Γουιάνα",
		"GG": "Γκέρνσεϊ",
		"GH": "Γκάνα",
		"GI": "Γιβραλτάρ",
		"GL": "Γροιλανδία",
		"GM": "Γκάμπια",
		"GN": "Γκινέα",
		"GP": "Γουαδελούπη",
		"GQ": "Ισημερινή Γουινέα",
		"GR": "Ελλάδα",
		"GS": "Νότια Γεωργία και τα Νότια Σάντουιτς Νησιά",
		"GT": "Γουατεμάλα",
		"GU": "Γκουάμ",
		"GW": "Γουινέα-Μπισάου",
		"GY": "Γουιάνα",
		"HK": "Χονγκ Κονγκ",
		"HM": "Heard Island και McDonald Islands",
		"HN": "Ονδούρα",
		"HR": "την Κροατία",
		"HT": "Αΐτη",
		"HU": "Ουγγαρία",
		"IC": "Κανάριοι Νήσοι",
		"ID": "Ινδονησία",
		"IE": "Ιρλανδία",
		"IL": "Ισραήλ",
		"IM": "Νήσος Μαν",
		"IN": "Ινδία",
		"IO": "Βρετανική επικράτεια Ινδικού Ωκεανού",
		"IQ": "Ιράκ",
		"IR": "Ιράν",
		"IS": "Ισλανδία",
		"IT": "Ιταλία",
		"JE": "Φανέλα",
		"JM": "Ιαμαϊκή",
		"JO": "Ιορδανία",
		"JP": "Ιαπωνία",
		"KE": "Κενύα",
		"KG": "Κιργιζιστάν",
		"KH": "Καμπότζη",
		"KI": "Κιριμπάτι",
		"KM": "Κομόρες",
		"KN": "Saint Kitts and Nevis",
		"KP": "Βόρεια Κορέα",
		"KR": "Νότια Κορέα",
		"KW": "Κουβέιτ",
		"KY": "Νησιά Κέιμαν",
		"KZ": "Καζακστάν",
		"LA": "Λάος",
		"LB": "Λίβανος",
		"LC": "Αγία Λουκία",
		"LI": "Λιχτενστάιν",
		"LK": "Σρι Λάνκα",
		"LR": "Λιβερία",
		"LS": "Λεσότο",
		"LT": "Λιθουανία",
		"LU": "Λουξεμβούργο",
		"LV": "Λατβία",
		"LY": "Λιβύη",
		"MA": "Μαρόκο",
		"MC": "Μονακό",
		"MD": "Μολδαβία",
		"ME": "Μαυροβούνιο",
		"MF": "Άγιος Μαρτίνος",
		"MG": "Μαδαγασκάρη",
		"MH": "Νησιά Μάρσαλ",
		"MK": "Βόρεια Μακεδονία",
		"ML": "Μάλι",
		"MM": "Μιανμάρ (Βιρμανία)",
		"MN": "Μογγολία",
		"MO": "Μακάο",
		"MP": "Βόρειες Μαριάνες Νήσους",
		"MQ": "Μαρτινίκα",
		"MR": "Μαυριτανία",
		"MS": "Μονσεράτ",
		"MT": "Μάλτα",
		"MU": "Μαυρίκιος",
		"MV": "Μαλδίβες",
		"MW": "Μαλάουι",
		"MX": "Μεξικό",
		"MY": "Μαλαισία",
		"MZ": "Μοζαμβίκη",
		"NA": "Ναμίμπια",
		"NC": "Νέα Καληδονία",
		"NE": "Νίγηρας",
		"NF": "Νησί Νόρφολκ",
		"NG": "Νιγηρία",
		"NI": "Νικαράγουα",
		"NL": "Ολλανδία",
		"NO": "Νορβηγία",
		"NP": "Νεπάλ",
		"NR": "Ναούρου",
		"NU": "Niue",
		"NZ": "Νέα Ζηλανδία",
		"OM": "Ομάν",
		"PA": "Παναμάς",
		"PE": "Περού",
		"PF": "Γαλλική Πολυνησία",
		"PG": "Παπούα Νέα Γουινέα",
		"PH": "Φιλιππίνες",
		"PK": "Πακιστάν",
		"PL": "Πολωνία",
		"PM": "Saint Pierre and Miquelon",
		"PN": "Νησιά Πίτκερν",
		"PR": "Πορτορικό",
		"PS": "Παλαιστίνη",
		"PT": "Πορτογαλία",
		"PW": "Παλάου",
		"PY": "Παραγουάη",
		"QA": "Κατάρ",
		"RE": "Ξανασμίξιμο",
		"RO": "Ρουμανία",
		"RS": "Σερβία",
		"RU": "Ρωσία",
		"RW": "Ρουάντα",
		"SA": "Σαουδική Αραβία",
		"SB": "Νησιά Σολομώντα",
		"SC": "Σεϋχέλλες",
		"SD": "Σουδάν",
		"SE": "Σουηδία",
		"SG": "Σιγκαπούρη",
		"SH": "Αγία Ελένη Ανάληψη και Τριστάν ντα Κούνια",
		"SI": "Σλοβενία",
		"SJ": "Svalbard και Jan Mayen",
		"SK": "Σλοβακία",
		"SL": "Σιέρα Λεόνε",
		"SM": "Άγιος Μαρίνος",
		"SN": "Σενεγάλη",
		"SO": "Σομαλία",
		"SR": "Σουρινάμ",
		"SS": "Νότιο Σουδάν",
		"ST": "Σάο Τομέ και Πρίνσιπε",
		"SV": "Ελ Σαλβαδόρ",
		"SX": "Sint Maarten",
		"SY": "Συρία",
		"SZ": "Σουαζιλάνδη",
		"SZ-2": "Εσβατίνι",
		"TA": "Τριστάν ντα Κούνια",
		"TC": "Νήσος Τερκς και Κάικος",
		"TD": "Τσαντ",
		"TF": "Γαλλικά νότια και ανταρκτικά εδάφη",
		"TG": "Τόγκο",
		"TH": "Σιάμ",
		"TJ": "Τατζικιστάν",
		"TK": "Τοκελάου",
		"TL": "Ανατολικό Τιμόρ",
		"TM": "Τουρκμενιστάν",
		"TN": "Τυνησία",
		"TO": "Τόνγκα",
		"TR": "Τουρκία",
		"TT": "Τρινιντάντ και Τομπάγκο",
		"TV": "Τουβαλού",
		"TW": "Ταϊβάν",
		"TZ": "Τανζανία",
		"UA": "Ουκρανία",
		"UG": "Ουγκάντα",
		"US": "ΗΠΑ",
		"UN": "Ηνωμένα Έθνη",
		"US-2": "ΜΑΣ",
		"UY": "Ουρουγουάη",
		"UZ": "Ουζμπεκιστάν",
		"VA": "Πόλη του Βατικανού",
		"VC": "Άγιος Βικέντιος και Γρεναδίνες",
		"VE": "Βενεζουέλα",
		"VG": "Βρετανικές Παρθένοι Νήσοι",
		"VI": "Παρθένοι Νήσοι των ΗΠΑ",
		"VN": "Βιετνάμ",
		"VU": "Βανουάτου",
		"WF": "Wallis και Futuna",
		"WS": "Σαμόα",
		"XK": "Κοσσυφοπέδιο",
		"YE": "Γέμενη",
		"YT": "Μαγιότ",
		"ZA": "Νότια Αφρική",
		"ZM": "Ζάμπια",
		"ZW": "Ζιμπάμπουε"
	},
	"languages": {
		"bg-BG": "Βουλγαρικά",
		"cs-CZ": "Τσεχικά",
		"de-DE": "Γερμανικά",
		"en-US": "Αγγλικά",
		"el-GR": "Ελληνικά",
		"es-ES": "Ισπανικά",
		"fr-FR": "Γαλλικά",
		"it-IT": "Ιταλικά",
		"nl-NL": "Ολλανδικά",
		"no-NO": "Νορβηγικά",
		"pl-PL": "Πολωνικά",
		"ro-RO": "Ρουμανικά",
		"sv-SE": "Σουηδικά"
	},
	"traceIdBadge": {
		"traceIdLabel": "Αναγνωριστικό ιχνηλάτησης"
	},
	"units": {
		"kg": "kg",
		"ton": "t",
		"m3": "M3",
		"co2": "CO\u2082 ισοδ.",
		"kgCO2": "kg CO\u2082 ισοδ."
	}
}
